// Numéro civique RECA d'une résidence, lu au début de la première ligne d'adresse (« 148A rue … », « 12-14 rue … »).
// Suffixes conservés; aucun numéro inventé si la ligne n'en commence pas par un.

const civicPattern = /^\s*(\d{1,6}(?:\s?[A-Za-z](?![A-Za-zÀ-ÿ]))?(?:\s?[-–]\s?\d{1,6}(?:[A-Za-z](?![A-Za-zÀ-ÿ]))?)?)(?=[\s,]|$)/

export function civicNumber(addressLine1: string | null): string | null {
  const match = addressLine1 ? civicPattern.exec(addressLine1) : null
  return match?.[1] ? match[1].replace(/\s+/g, '').replace('–', '-').toUpperCase() : null
}

export interface LabelBox {
  id: string
  x: number
  y: number
  width: number
  height: number
}

/**
 * Étiquettes sans collision : placées dans l'ordre de priorité reçu (active, sélectionnée, puis ordre de la route);
 * une étiquette qui en chevaucherait une déjà placée est omise (la pastille reste).
 */
export function placeLabels(boxes: readonly LabelBox[], gap = 4): Set<string> {
  const kept: LabelBox[] = []
  for (const box of boxes) {
    const overlaps = kept.some(
      (other) =>
        box.x < other.x + other.width + gap &&
        other.x < box.x + box.width + gap &&
        box.y < other.y + other.height + gap &&
        other.y < box.y + box.height + gap,
    )
    if (!overlaps) kept.push(box)
  }
  return new Set(kept.map((box) => box.id))
}
